import React, { createContext, useContext, useState, useCallback } from 'react';
import PopupModal from '../components/common/PopupModal';

const ModalContext = createContext(null);

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: '',
    message: '',
    isConfirm: false,
    onConfirm: null,
    isDanger: false
  });

  const showAlert = useCallback((title, message) => {
    setModalConfig({
      isOpen: true,
      title,
      message,
      isConfirm: false,
      onConfirm: () => setModalConfig(prev => ({ ...prev, isOpen: false }))
    });
  }, []);

  const showConfirm = useCallback((title, message, onConfirm, isDanger = false) => {
    setModalConfig({
      isOpen: true,
      title,
      message,
      isConfirm: true,
      onConfirm: () => {
        setModalConfig(prev => ({ ...prev, isOpen: false }));
        if (onConfirm) onConfirm();
      },
      isDanger
    });
  }, []);

  const handleCancel = useCallback(() => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
  }, []);

  return (
    <ModalContext.Provider value={{ showAlert, showConfirm }}>
      {children}
      <PopupModal
        isOpen={modalConfig.isOpen}
        title={modalConfig.title}
        message={modalConfig.message}
        onConfirm={modalConfig.onConfirm}
        onCancel={modalConfig.isConfirm ? handleCancel : null}
        confirmText={modalConfig.isConfirm ? (modalConfig.isDanger ? '確定刪除' : '確定') : '確定'}
        cancelText="取消"
        isDanger={modalConfig.isDanger}
      />
    </ModalContext.Provider>
  );
};
